// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"368":"a0bf23e181e14d64e97c","677":"638229ef108f09aeafda"}[chunkId] + ".js";
};